<template>
  <Badge v-if="swimmer" icon="pool">
    {{ swimmer ? "Swimmer" : null }}
  </Badge>
</template>

<script>
import Badge from "@/components/UI/Badge.vue";

export default {
  name: "Swimmer",
  props: ["swimmer"],
  components: {
    Badge,
  },
};
</script>
